import { useContext } from 'react';
import MikeSidePanelNavigation from '../mike-sidepanel-navigation/MikeSidePanelNavigation';
import MikeSidePanelNavigationItem from '../mike-sidepanel-navigationitem/MikeSidePanelNavigationItem';
import Plus from '../../icons/Plus.svg?react';
import Minus from '../../icons/Minus.svg?react';
import ZoomToArea from '../../icons/ZoomToArea.svg?react';
import { GlobalContext } from '../../store/Store';
import { GlobalState } from '../app/AppWrapper';
import { zoomToMeshExtent } from '../map/MapFunctions';
import './MapToolBar.css';

const MapToolBar = () => {
  const [_gs] = useContext(GlobalContext);
  const globalState: GlobalState = _gs;

  const mapZoomIn = () => {
    (globalState.map as any).olMap.getView().animate({
      zoom: (globalState.map as any).olMap.getView().getZoom() + 1,
      duration: 200,
    });
  };

  const mapZoomOut = () => {
    (globalState.map as any).olMap.getView().animate({
      zoom: (globalState.map as any).olMap.getView().getZoom() - 1,
      duration: 200,
    });
  };

  const mapZoomToExtent = () => {
    zoomToMeshExtent((globalState.map as any).olMap);
  };

  return (
    <div className="side-nav">
      <MikeSidePanelNavigation >     
        <MikeSidePanelNavigationItem
          noHighlight={true}
          value={'zoom-in'}
          icon={<Plus />}
          onClick={mapZoomIn}
          tooltipTitle={"Zoom in"}
          tooltipPlacement={"right"}
        />       
        <MikeSidePanelNavigationItem
          noHighlight={true}
          value={'zoom-out'}
          icon={<Minus />}
          onClick={mapZoomOut}
          tooltipTitle={"Zoom out"}
          tooltipPlacement={"right"}
        />
        <MikeSidePanelNavigationItem
          noHighlight={true}
          value={'zoom-to-mesh-extent'}
          icon={<ZoomToArea />}
          onClick={mapZoomToExtent}
          tooltipTitle={"Zoom to extent"}
          tooltipPlacement={"right"}
        />
      </MikeSidePanelNavigation>
    </div>
  );
};

export default MapToolBar;
